module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-select"
  }, _vm._l((_vm.safeOptions), function(option) {
    return _c('div', {
      class: _vm.getOptionClasses(option)
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": _vm.safeName,
        "id": _vm.getOptionId(option)
      },
      domProps: {
        "value": option.value,
        "checked": _vm.isOptionSelected(option)
      },
      on: {
        "input": function($event) {
          _vm.onOptionSelect(option)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.getOptionId(option)
      }
    }, [_vm._v("\n            " + _vm._s(option.label) + "\n        ")])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d661f27e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/tab-select/index.vue
// module id = 2107
// module chunks = 2